<template>
  <v-content class="mt-0 pt-0">
    <v-container fluid>
      <v-toolbar flat color="white" class="elevation-1">
        <v-toolbar-title>{{ $t('imports screen') }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <div>
        <v-btn-toggle v-model="screen">
          <v-tooltip bottom>
            <v-btn slot="activator" flat value="import" @click="openImport"><v-icon>arrow_downward</v-icon> {{ $t('Import') }}</v-btn>
            <span>{{ $t('Tooltip.import.screen') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn slot="activator" flat value="export" @click="openExport"><v-icon>arrow_upward</v-icon> {{ $t('Export') }}</v-btn>
            <span>{{ $t('Tooltip.export.screen') }}</span>
          </v-tooltip>
        </v-btn-toggle>
        </div>
      </v-toolbar>

      <v-card>
        <router-view></router-view>
      </v-card>

    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      screen : ""
    }
  },

  computed : {
    screenType() {
      let p = this.$route.path;
      if (!!p && p.lastIndexOf("/") > 0) {
        return p.substring(p.lastIndexOf("/") + 1);
      }
      return "";
    }
  },

  methods : {
    openImport() {
      this.$router.push({"name" : "importTmpl"});
    },
    openExport() {
      this.$router.push({"name" : "exportTmpl"});
    }
  },

  mounted() {
    this.screen = this.screenType;
  }
}
</script>
